import { useQuery } from '@tanstack/react-query';
import { dashboardStats, recentActivity, monthlyRevenue } from '../data/dummyData';
import { apiRequest } from '../lib/queryClient';

// Base query key for dashboard
const dashboardKey = 'dashboard';

/**
 * Hook for fetching and managing dashboard data
 */
export function useDashboard() {
  // In a real app, this would make an API call
  // const fetchDashboardStats = async () => {
  //   // Simulate API delay
  //   await new Promise(resolve => setTimeout(resolve, 500));
    
  //   return dashboardStats;
  // };
  
  // // Query for fetching dashboard stats
  // const statsQuery = useQuery({
  //   queryKey: [dashboardKey, 'stats'],
  //   queryFn: fetchDashboardStats
  // });
  
  // // In a real app, this would make an API call
  // const fetchRecentActivity = async () => {
  //   // Simulate API delay
  //   await new Promise(resolve => setTimeout(resolve, 500));
    
  //   return recentActivity;
  // };
  
  // // Query for fetching recent activity
  // const activityQuery = useQuery({
  //   queryKey: [dashboardKey, 'activity'],
  //   queryFn: fetchRecentActivity
  // });
  
  // // In a real app, this would make an API call
  // const fetchRevenueData = async () => {
  //   // Simulate API delay
  //   await new Promise(resolve => setTimeout(resolve, 500));
    
  //   return monthlyRevenue;
  // };
  
  // // Query for fetching revenue data
  // const revenueQuery = useQuery({
  //   queryKey: [dashboardKey, 'revenue'],
  //   queryFn: fetchRevenueData
  // });
  
  // // In a real app, this would make an API call
  // const fetchUserGrowthData = async () => {
  //   // Simulate API delay
  //   await new Promise(resolve => setTimeout(resolve, 500));
    
  //   // Generate user growth data (in a real app, this would come from the API)
  //   return {
  //     labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  //     data: [1200, 1350, 1500, 1640, 1800, 2500]
  //   };
  // };
  
  // // Query for fetching user growth data
  // const userGrowthQuery = useQuery({
  //   queryKey: [dashboardKey, 'userGrowth'],
  //   queryFn: fetchUserGrowthData
  // });
  
  // // In a real app, this would make an API call
  // const fetchUserTypeData = async () => {
  //   // Simulate API delay
  //   await new Promise(resolve => setTimeout(resolve, 500));
    
  //   // In a real app, this would come from the API
  //   return {
  //     freeUsers: 1650,
  //     premiumUsers: 850
  //   };
  // };
  
  // // Query for fetching user type data
  // const userTypeQuery = useQuery({
  //   queryKey: [dashboardKey, 'userType'],
  //   queryFn: fetchUserTypeData
  // });
  
  // return {
  //   stats: statsQuery.data || {},
  //   activity: activityQuery.data || [],
  //   revenue: revenueQuery.data || [],
  //   userGrowth: userGrowthQuery.data || { labels: [], data: [] },
  //   userType: userTypeQuery.data || { freeUsers: 0, premiumUsers: 0 },
  //   isStatsLoading: statsQuery.isLoading,
  //   isActivityLoading: activityQuery.isLoading,
  //   isRevenueLoading: revenueQuery.isLoading,
  //   isUserGrowthLoading: userGrowthQuery.isLoading,
  //   isUserTypeLoading: userTypeQuery.isLoading,
  //   isStatsError: statsQuery.isError,
  //   isActivityError: activityQuery.isError,
  //   isRevenueError: revenueQuery.isError,
  //   isUserGrowthError: userGrowthQuery.isError,
  //   isUserTypeError: userTypeQuery.isError,
  //   statsError: statsQuery.error,
  //   activityError: activityQuery.error,
  //   revenueError: revenueQuery.error,
  //   userGrowthError: userGrowthQuery.error,
  //   userTypeError: userTypeQuery.error
  // };


  const fetchDashboard = async () => {
      const queryParams = new URLSearchParams();
     
  
     
      const response = await apiRequest(
        `/admin/dashboard`,
        {
          method: "GET",
        }
      );
      return response;
    };
  return {
    fetchDashboard,
  };


}